<template>
  <figure style="width: 100%; height: 100%;display: flex;align-items: center;justify-content: center;">
    <chart :options="pieOptions" @click="sentimentFilter" style='width: 100%; height: 100%' ref="pie" auto-resize v-if="dataState === 'ready'"></chart>
    <template v-else-if="dataState === 'loading'">
      <center>
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </center>
    </template>
    <template v-else-if="dataState === 'noData'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
    </template>
    <template v-else-if="dataState === 'error'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
    </template>
  </figure>
</template>

<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataState: 'loading',
      pieOptions: {
        tooltip: {trigger: 'item', formatter: '{a} <br/>{b} : {c} ({d}%)'},
        series: [{
          name: 'Sentiment',
          type: 'pie',
          data: [
            {value: 0, name: 'Very Negative'},
            {value: 0, name: 'Negative'},
            {value: 0, name: 'Neutral'},
            {value: 0, name: 'Positive'},
            {value: 0, name: 'Very Positive'},
            {value: 0, name: 'Unknown'}
          ]
        }]
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getSentiment', 'getQuery']),
    filterSentiment: function () {
      return this.getSentiment
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setCustomFilters', 'resetSentimentFilter']),
    sentimentFilter: function (type) {
      var sentiment = ''
      if (type) {
        if (type.name === 'Very Negative') {
          sentiment = -2
        } else if (type.name === 'Negative') {
          sentiment = -1
        } else if (type.name === 'Neutral') {
          sentiment = 0
        } else if (type.name === 'Positive') {
          sentiment = 1
        } else if (type.name === 'Very Positive') {
          sentiment = 2
        } else {
          return
        }

        var filter = this.filterSentiment.slice()
        var index = filter.indexOf(sentiment)
        if (index >= 0) {
          filter.splice(index, 1)
          this.setCustomFilters({sentiment: filter})
        } else {
          filter.push(sentiment)
          this.setCustomFilters({sentiment: filter})
        }
      }
    },
    getData: function () {
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getNewsSentiment', this.getQuery({}))
      ]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.pieOptions.series = []
          var unknown = 0
          var vneg = 0
          var neg = 0
          var neu = 0
          var pos = 0
          var vpos = 0

          if (response.data.payload.find(function (element) { return Number(element._sentiment) === 100 })) {
            unknown = response.data.payload.find(function (element) { return Number(element._sentiment) === 100 })._article_count
          }
          if (response.data.payload.find(function (element) { return Number(element._sentiment) === -2 })) {
            vneg = response.data.payload.find(function (element) { return Number(element._sentiment) === -2 })._article_count
          }
          if (response.data.payload.find(function (element) { return Number(element._sentiment) === -1 })) {
            neg = response.data.payload.find(function (element) { return Number(element._sentiment) === -1 })._article_count
          }
          if (response.data.payload.find(function (element) { return Number(element._sentiment) === 0 })) {
            neu = response.data.payload.find(function (element) { return Number(element._sentiment) === 0 })._article_count
          }
          if (response.data.payload.find(function (element) { return Number(element._sentiment) === 1 })) {
            pos = response.data.payload.find(function (element) { return Number(element._sentiment) === 1 })._article_count
          }
          if (response.data.payload.find(function (element) { return Number(element._sentiment) === 2 })) {
            vpos = response.data.payload.find(function (element) { return Number(element._sentiment) === 2 })._article_count
          }

          this.pieOptions.series.push({
            name: 'Sentiment',
            type: 'pie',
            data: [
              {value: unknown, name: 'Unknown', itemStyle: {color: '#9f9f9f'}},
              {value: vneg, name: 'Very Negative', itemStyle: {color: '#e80036'}},
              {value: neg, name: 'Negative', itemStyle: {color: '#ff5930'}},
              {value: neu, name: 'Neutral', itemStyle: {color: '#5895b3'}},
              {value: pos, name: 'Positive', itemStyle: {color: '#00bfa9'}},
              {value: vpos, name: 'Very Positive', itemStyle: {color: '#00e8af'}}
            ]
          })

          if (unknown === 0 && vneg === 0 && neg === 0 && neu === 0 && pos === 0 && vpos === 0) {
            this.dataState = 'noData'
          } else {
            this.dataState = 'ready'
          }
        } else {
          this.dataState = 'error'
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (!underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.getData()
        }
      }
    },
    loading: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal === true) {
          let pie = this.$refs.pie
          if (pie) {
            pie.showLoading({
              text: '',
              color: '#4ea397',
              maskColor: 'rgba(255, 255, 255, 0.4)'
            })
          }
        } else {
          let pie = this.$refs.pie
          if (pie) {
            pie.hideLoading()
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/NewsSentimentPieChart.vue